export function mapReduce<T extends string | number>(keys: T[], mapping: (key: T) => any, oo = {}): Record<T, any> {
  return keys.reduce((oo, key: T) => {
    oo[key] = mapping(key);
    return oo;
  }, oo as Record<T, any>);
}
